import {
    GET_FOLLOWED_BUSINESSES_START,
    GET_FOLLOWED_BUSINESSES_SUCCESS,
    GET_FOLLOWED_BUSINESSES_ERROR
} from "../../actions/ActionTypes";

const initialState = {
    loading: false,
    data: null,
    error: null,
};

const getFollowedBusinessesReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_FOLLOWED_BUSINESSES_START:
            return {
                ...state,
                loading: true,
                error: null,
            };
        case GET_FOLLOWED_BUSINESSES_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
            };
        case GET_FOLLOWED_BUSINESSES_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        default:
            return state;
    }
};

export default getFollowedBusinessesReducer;
